import { SVGProps } from 'react'

function ProfileIndio(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="21.5" cy="21.5" r="20.7" stroke="white" strokeWidth="1.6" />
      <circle cx="21.5001" cy="15.2074" r="8.11463" stroke="white" strokeWidth="1.6" />
      <path d="M37.8076 34.0855C34.597 28.1378 28.497 24.1221 21.5 24.1221C14.5031 24.1221 8.40309 28.1378 5.1925 34.0855" stroke="white" strokeWidth="1.6" />
    </svg>

  )
}

export default ProfileIndio
